import React from "react";
import { mandatoryColumns } from "../../constants/static";

const formatValues = (value) => {
  return value.replaceAll("|", ", ");
};

export default function FilterGroupColumnTDs({ filterGroups, collection }) {
  // If there are no filter groups, return null
  if (!filterGroups?.length > 0) {
    return null;
  }

  // Filter out groups that don't meet criteria
  const filteredGroups = filterGroups.filter(
    (group) =>
      group.type < 4 && !group.hideAsColumn && group.id !== mandatoryColumns.ItemCategoryTitle
  );

  // Check if the current filterRow is missing from the collection
  const isGroupInCollection = (filterRow) =>
    collection.some((item) => item.fieldName === filterRow.id);

  // Render the data inside the <td> based on the group and collection
  const renderGroupData = (group) => {
    const hasMultipleValues = group.values?.length > 1;
    const sortedValues = group.values?.sort((a, b) => a - b).join(" / ");

    const displayValue = hasMultipleValues
      ? sortedValues
      : group.values?.length === 1
        ? formatValues(group.values[0])
        : "";

    return `${displayValue} ${group.fieldUnit || ""}`.trim();
  };

  // Generate table cells for filtered groups
  return filteredGroups.map((filterRow) => {
    const groupNotInThisRow = !isGroupInCollection(filterRow);

    if (groupNotInThisRow) {
      return (
        <td className="c-parts-listing__table-item" key={filterRow.id}>
          -
        </td>
      );
    }

    const relatedGroup = collection.find(
      (item) => item.fieldName === filterRow.id
    );

    if (!relatedGroup) {
      return null; // If no related group exists, return null
    }

    return (
      <td
        className={`c-parts-listing__table-item ${relatedGroup.values?.length > 1 ? "multi" : ""}`}
        key={relatedGroup.fieldHeader}
      >
        <span className="c-parts-listing__label">{relatedGroup.fieldHeader}</span>
        {renderGroupData(relatedGroup)}
      </td>
    );
  });
}
